import { Goal } from '@griply/types';

import { filterGoals } from './filter-goals';

export type RoadmapGoalFilterSettings = {
  hideUnplannedGoals?: boolean;
  hideCompletedGoals?: boolean;
  hideArchivedGoals?: boolean;
};

export const filterRoadmapGoals = (
  goals: Goal[],
  settings: RoadmapGoalFilterSettings,
): Goal[] =>
  filterGoals(goals, {
    hideUnplanned: settings.hideUnplannedGoals,
    hideCompleted: settings.hideCompletedGoals,
    hideArchived: settings.hideArchivedGoals ?? true,
  });
